import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'logShowDate',
    standalone: false
})
export class LogShowDatePipe implements PipeTransform {
  transform(value: string): string {

    if (!value) { // check if the value is null before performing any transformations
      return null;
    }

    // Format the logDateTime using the DatePipe
    const datePipe = new DatePipe('nl-NL');
    let formattedDate = datePipe.transform(value, 'EEEE', 'CEST', 'nl-NL');

    // Capitalize the first letter of the formatted date
    if (formattedDate) {
      formattedDate =        formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    }

    // Format the logDateTime using the DatePipe again for the second part
    const formattedDatePartTwo = datePipe.transform(
      value,
      'd MMMM y',
      'CEST',
      'nl-NL'
    );

    // Combine the formatted parts
    return formattedDate + ' ' + formattedDatePartTwo;
  }
}
